const namespace = {
  title: "Quartiers similaires",
  description:
    "Découvrez des quartiers similaires à celui-ci et comparez-les en termes de caractéristiques et services de proximité.",
  descriptionWithNeighborhood:
    "Découvrez des quartiers similaires à {{neighborhoodName}} et comparez-les en termes de caractéristiques et services de proximité.",
  noData:
    "Les quartiers similaires ne sont pas disponibles pour cet emplacement.",
  tags: {
    lessExpensive: "Moins cher",
    comparable: "Comparable",
    moreExpensive: "Plus cher",
  },
  pagination: {
    previous: "Afficher moins",
    next: "Afficher plus",
  },
} as const;

export default namespace;
